import Link from "next/link";

import { Button } from "@/components/ui/button";
import { PublicStoreCard } from "@/features/public-site/components/PublicStoreCard";
import { LoadingSkeleton } from "@/components/loading-skeleton";
import type { CustomerProduct, CustomerShopSummary } from "@/features/shop/types/customer-shop";

type PopularStoresSectionProps = {
  products: CustomerProduct[];
  shops: CustomerShopSummary[];
  isLoading?: boolean;
};

export function PopularStoresSection({
  products,
  shops,
  isLoading = false,
}: PopularStoresSectionProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-semibold uppercase tracking-[0.24em] text-primary">
            Popular Stores
          </p>
          <h2 className="text-3xl font-black tracking-tight text-foreground">
            Stores active near you today.
          </h2>
        </div>
        <Button asChild variant="outline" className="rounded-sm border-primary/30 text-primary">
          <Link href="/shop/store-list">View locations</Link>
        </Button>
      </div>

      {isLoading ? (
        <LoadingSkeleton variant="rows" count={3} />
      ) : (
      <div className="grid gap-4">
        {shops.map((shop) => {
          const productCount = products.filter((product) => {
            if (typeof product.shopId === "string") {
              return product.shopId === shop._id;
            }
            return product.shopId?._id === shop._id;
          }).length;

          return <PublicStoreCard key={shop._id} shop={shop} productCount={productCount} />;
        })}
      </div>
      )}
    </div>
  );
}
